export const checkForUndefined = (str = '') => {
  const IS_PROD = process.env.NX_ENV === 'PROD';
  if (!IS_PROD && str && str.includes('undefined')) {
    throw Error(`Critical URL includes undefined: ${str}`);
  }
};
